import GoogleAnalyticsCustomDimensions from "constants/googleAnalyticsCustomDimension";
import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";

/* Creates a new instance for housing product type. */
export default class BasicListingCard {
    constructor(url, listing) {
      this.url = url;   
      this.marketId = listing.marketId;     
      this.marketName = listing.marketName;
      this.id = listing.id;
      this.isBasic = listing.isBasic === "true";
    }
  
    /**
     * This function returns a new GoogleAnalyticsEvent object with the event category, event action,
     * event label and custom dimensions set.
     * @returns A new instance of the GoogleAnalyticsEvent class for card click.
     */
    getCardGoogleAnalyticsEvent() {
      const customDimensions = { 
        [GoogleAnalyticsCustomDimensions.MarketId().getName()] : 
        this.marketId,
        [GoogleAnalyticsCustomDimensions.MarketName().getName()] : 
        this.marketName,
        [GoogleAnalyticsCustomDimensions.PlanId().getName()] : 
        this.id,
        [GoogleAnalyticsCustomDimensions.IsPaid().getName()] : 
        !this.isBasic,
      };

      const googleAnalyticsDTO = new GoogleAnalyticsEvent('Card-Clicks', 'SRP-Card-Clicks', this.url, customDimensions);
      
      return googleAnalyticsDTO;
    }
  }
  